import UIComponent from '../../common/UIComponent';
import { preloadImg, secondFormat } from '../../common/Utils';
import './index.css';

export default class Thumbnail extends UIComponent {
  constructor(rootNode, interfaces, config) {
    super();
    this.interfaces = interfaces;
    this.rootNode = rootNode;
    this.mainNode = null;
    this.spotTimeTextNode = null;
    this.config = config;
    this.config = {
      enable: true,
      urls: [
        'http://1253248467.vod2.myqcloud.com/dd85da51vodtransgzp1253248467/6929da573270835011924448131/imageSprite/imageSprite_130801_0.jpg'
      ], // 有多张大图就多个url就好
      interval: 10,
      pic_num: 100, // 雪碧小图总个数
      col: 10, // 截图列数
      row: 10, // 截图行数
      height: 90, // 缩略图高度
      width: 160 // 缩略图宽度
    };
    //已完成预加载的图像文件记录
    this._preloadMark = {};
    //初始化元素
    this.init();
  }

  init() {
    this.mainNode = document.createElement('div');
    this.mainNode.setAttribute('class', 'vhallPlayer-thumbnail hide');

    this.spotTimeTextNode = document.createElement('div');
    this.spotTimeTextNode.setAttribute('class', 'vhallPlayer-thumbnail-spot-time');
    this.mainNode.appendChild(this.spotTimeTextNode);

    this.rootNode.appendChild(this.mainNode);
  }

  get usable() {
    const { enable, urls, pic_num } = this.config;
    return enable && urls && urls.length > 0 && pic_num > 0;
  }

  /**
   * 雪碧图文件URL
   * @param {*} index
   * @returns
   */
  getUrlByIndex(index) {
    return index >= 0 && index < this.config.urls.length ? this.config.urls[index] : '';
  }

  /**
   * 预加载图像
   * @param {*} index
   * @returns
   */
  preload(index) {
    if (this._preloadMark[index]) {
      return;
    }
    const { urls } = this.config;
    const len = urls.length;
    const arr = [];
    index > 0 && arr.push(index - 1);
    arr.push(index);
    index > 0 && index < len - 1 && arr.push(index + 1);
    arr.map(item => {
      if (!this._preloadMark[item] && item >= 0 && item < len) {
        this._preloadMark[item] = 1;
        preloadImg(urls[item], () => {
          this._preloadMark[item] = 2;
        });
      }
    });
  }

  /**
   * 根据进度条位置状态，获取雪碧图所需参数和样式
   * @param {*} offsetX
   * @param {*} progessWidth
   * @param {*} now
   * @param {*} containerWidth
   * @param {*} containerHeight
   * @returns
   */
  getPosition(offsetX, progessWidth, now, containerWidth = 0, containerHeight = 0) {
    const { interval, pic_num, row, col, width, height } = this.config;
    let index = Math.ceil(now / interval); // 当前时间对应的图像索引
    index = index > pic_num ? pic_num : index;
    const urlIndex = index < row * col ? 0 : Math.ceil(index / (row * col)) - 1; // 当前图像所在的url索引
    const indexInPage = index - urlIndex * (col * row); // 当前图像在当前url中的索引
    const rowIndex = indexInPage > 0 ? Math.ceil(indexInPage / col) - 1 : 0; // 当前图像在当前url中的行索引
    const colIndex = indexInPage > 0 ? indexInPage - rowIndex * col - 1 : 0; // 当前图像在当前url中的列索引
    let swidth = 0; // containerWidth || width
    let sHeight = 0; // swidth * height / width

    // 根据入参的宽高适配样式
    if (containerWidth && containerHeight) {
      const per = containerWidth / containerHeight;
      if (per < width / height) {
        sHeight = containerHeight;
        swidth = sHeight * (width / height);
        // swidth = containerWidth
        // sHeight = swidth / (width / height)
      } else {
        swidth = containerWidth;
        sHeight = swidth / (width / height);
      }
    } else if (!containerHeight) {
      swidth = containerWidth || width;
      sHeight = swidth / (width / height);
    } else if (!containerWidth) {
      sHeight = containerHeight || height;
      swidth = sHeight * (width / height);
    }
    const url = this.getUrlByIndex(urlIndex);
    let per = 0;
    if (offsetX < this.mainNode.offsetWidth / 2) {
      per = 0;
    } else if (offsetX > progessWidth - this.mainNode.offsetWidth) {
      per = ((progessWidth - this.mainNode.offsetWidth) / progessWidth) * 100;
    } else {
      per = ((offsetX - this.mainNode.offsetWidth / 2) / progessWidth) * 100;
    }
    return {
      urlIndex,
      rowIndex,
      colIndex,
      url,
      height: sHeight,
      width: swidth,
      style: {
        backgroundImage: `url(${url})`,
        backgroundSize: `${swidth * col}px auto`,
        backgroundPosition: `-${colIndex * swidth}px -${rowIndex * sHeight}px`,
        width: `${swidth}px`,
        height: `${sHeight}px`,
        left: `${per}%`
      }
    };
  }

  // 更新内容与样式
  update(offsetX, progessWidth, now, containerWidth = 0, containerHeight = 0) {
    if (this.usable) {
      //更新时间点显示文本
      const currentTimeStr = secondFormat(now);
      this.spotTimeTextNode.innerText = currentTimeStr;
      //更新雪碧图CSS样式
      const pos = this.getPosition(offsetX, progessWidth, now, containerWidth, containerHeight);
      this.preload(pos.urlIndex);
      Object.keys(pos.style).map(key => {
        this.mainNode.style[key] = pos.style[key];
      });
    }
  }

  //对外方法，显示元素
  show() {
    if (this.usable) {
      this.mainNode.classList.remove('hide');
    }
  }
  //对外方法，隐藏元素
  hide() {
    if (this.usable) {
      this.mainNode.classList.add('hide');
    }
  }
}
